import { apiJson } from './api'

export interface AppDownload {
  platform: 'windows' | 'macos' | 'android'
  filename: string
  url: string
  version: string | null
  size_bytes: number
}

export async function listDownloads(): Promise<AppDownload[]> {
  const data = await apiJson<{ items?: AppDownload[] }>('/api/downloads')
  return data.items ?? []
}
